<!-- views/Layout.vue -->
<template>
  <el-container style="height:100vh">
    <side-menu :menu-list="menuRoutes" />
    <el-main>
      <!-- <Header /> -->
      <router-view />
    </el-main>
  </el-container>
</template>

<script>
import SideMenu from '@/components/SideMenu.vue'
import { menuRoutes } from '@/router'
// import Header from '@/components/Header.vue'

export default {
  components: { 
    SideMenu, 
    // Header 
  },
  data() {
    return { menuRoutes }
  }
}
</script>
<style>
html, body {
  padding: 0;
  margin: 0;
}
.el-main {
  padding: 0 !important;
  width: calc(100% - 256px);
  height: 100vh;
  background: #eff6ff;
}
</style>